
import ClientDetails from '@/pages/ClientDetails';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

export default function ClientDetailsPage() {
  return (
    <ProtectedRoute requiredRole="staff">
      <ClientDetails />
    </ProtectedRoute>
  );
}
